import { useState, useEffect } from "react";
import { Row, Col, Typography, Card } from "antd";
import { useSelector } from "react-redux";
import Chart from "react-apexcharts";
import { BarChartOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const { Title, Text } = Typography;

const dummyAnalytics = {
  Email: 0,
  Search: 0,
  Writing: 0,
  Blog: 0,
  Social: 0,
  Manipulate: 0,
  Ads: 0,
  Marketing: 0,
  Sales: 0,
};

const CategoriesUsageCard = ({ analytics }) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState({
    chart: {
      fontFamily: "Manrope, sans-serif",
      height: 350,
      type: "radar",
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      dropShadow: {
        enabled: true,
        blur: 4,
        left: 1,
        top: 1,
        opacity: 0.1,
      },
      noData: {
        text: "Loading...",
      },
    },
    fill: {
      opacity: [1, 1],
    },
    stroke: {
      show: false,
      width: 0,
    },
    markers: {
      size: 0,
    },

    colors: ["#1890ff", "#52c41a"],

    dataLabels: {
      enabled: false,
    },
    yaxis: {
      show: false,
    },
    plotOptions: {
      radar: {
        polygons: {
          connectorColors: "#fff",
        },
      },
    },
    legend: {
      itemMargin: {
        horizontal: 24,
        vertical: 8,
      },
      horizontalAlign: "center",
      position: "bottom",
      fontSize: "14px",
      fontWeight: 500,
      markers: {
        radius: 8,
      },
      labels: {
        colors: "#595959",
      },
    },
  });
  const [series, setSeries] = useState([]);

  useEffect(() => {
    if (analytics.categories && analytics.categories.length > 0) {
      // Your existing data processing logic...
      const categories = analytics?.categories;
      const categoryUsage = {};
      categories?.forEach((category) => {
        categoryUsage[category[0]] = category[1];
      });

      // Update the series and xaxis categories here
      setSeries([
        {
          name: "Categories",
          data: Object.values(categoryUsage),
        },
      ]);
      setOptions((prevOptions) => ({
        ...prevOptions,
        xaxis: {
          categories: Object.keys(categoryUsage),
        },
      }));
    } else {
      // Set dummy data if analytics is not available
      setSeries([
        {
          name: "Categories",
          data: Object.values(dummyAnalytics),
        },
      ]);
      setOptions((prevOptions) => ({
        ...prevOptions,
        xaxis: {
          categories: Object.keys(dummyAnalytics),
        },
      }));
    }
  }, [analytics]);

  return (
    <Card
      style={{
        background: "white",
        border: "1px solid #e8e8e8",
        borderRadius: "16px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
        height: "100%",
      }}
      bodyStyle={{ padding: "24px" }}
    >
      {/* Header */}
      <div style={{ marginBottom: "20px" }}>
        <div
          style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}
        >
          <BarChartOutlined
            style={{
              fontSize: "20px",
              marginRight: "12px",
              color: "#1890ff",
            }}
          />
          <Title
            level={4}
            style={{
              color: "#262626",
              margin: 0,
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            {t("dashboard.categoryUsage")}
          </Title>
        </div>
        <Text
          style={{
            color: "#8c8c8c",
            fontSize: "14px",
            fontWeight: "400",
          }}
        >
          {t("dashboard.categoryUsageDesc")}
        </Text>
      </div>

      {/* Chart */}
      <div
        style={{
          background: "#fafafa",
          borderRadius: "12px",
          padding: "16px",
          border: "1px solid #f0f0f0",
        }}
      >
        <Chart
          options={options}
          series={series}
          type="radar"
          height={350}
          legend="legend"
        />
      </div>
    </Card>
  );
};

export default CategoriesUsageCard;
